/**
 * @module components\LeftMenu
 */
import store from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import core from '@/services/core';
import _ from "lodash";


@Component
export default class Dashboard extends Vue {
 moduleSelected:any="";
 totalTxn =  require('@/assets/totalTxn.svg');
 failedTxn = require('@/assets/failedTxn.svg');
 gtv  = require('@/assets/gtv.svg');
 mtd  = require('@/assets/mtd.svg');
 ytd  = require('@/assets/ytd.svg');
  successTxn = require('@/assets/successTxn.svg');
  cv = require('@/assets/successTxn.svg');
  cp = require('@/assets/gtv.svg');

dashBoardKeyVsIcon={

    "TOTAL_COUNT_FTD":this.totalTxn,
"SU_COUNT_FTD":this.successTxn,
"FL_COUNT_FTD":this.failedTxn,
"GTV_FTD":this.gtv,
"TOTAL_COUNT_MTD":this.mtd,
"SU_COUNT_MTD":this.successTxn,
"FL_COUNT_MTD":this.failedTxn,
"GTV_MTD":this.mtd,
  "GTV_YTD": this.ytd,
  "COMMERCIAL_VALUE": this.cv,
"COMMERCIAL_PCT" : this.cp


}

    loading = false;
  module=[];
    get superInitData(){
    return store.getters.updateSuperInitDataGet;
    }
    get staticData(){
        return store.getters.staticDataGet;
        }
    get clientDetails(){
    return store.getters.updateSuperInitDataGet?store.getters.updateSuperInitDataGet.payload2?store.getters.updateSuperInitDataGet.payload2[0]:null:null
}
reloadSuperInit(from){
  let client=[];
  if(from=='mount'){
    client= this.module.filter(el=>{
      return el.value==this.moduleSelected.value
  })
  }else{
    client= this.module.filter(el=>{
      return el.value==this.moduleSelected
  })
  }
    let request={
        token: store.getters.sessLoginDataGet.sessionId,
        requestModule: store.getters.sessLoginDataGet.requestModule,
        requestType: "WEB",
        merchantClientId: store.getters.sessLoginDataGet.clientId,
        requestFor:'DASH',
        aggId:client.length>0?client[0]['agg_id']:'',
        finoClientId:client.length>0?client[0]['value']:'',
};
      core
        .post({
          data: request,
          url: 'superinitWeb',
          method: 'post'
        })
      .then(response => {
        this.loading = false;

        store.dispatch('updateSuperInitDataAc', response);
      })
      .catch(error => {
        this.loading = false;
      });
}
get historys(){
    let superData=this.superInitData;
    let empArr=[];
    if(!superData.dashboard){
      return [];
    }
    superData.dashboard.forEach(element => {
        empArr.push({
            title: element.cardName,
            tilldate: element.bottomLine,
            value: element.value ,src:this.dashBoardKeyVsIcon[element['key']]
        })
      });
    return empArr;
}
setDrawerState(){
  store.dispatch('updateUserNavDataAc',false)
}
mounted(){
   this.module= this.staticData.payload.ccSearchModule.concat(this.staticData.payload.cdSearchModule);
   this.module=_.orderBy(this.module,'displayName');
   if(this.module.length==1)
    {
      this.moduleSelected={name:this.module[0]['displayName'],value:this.module[0]['value']};
        this.reloadSuperInit('mount');
    }
}
}
